if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  const registerProductMedia = () => {
    Alpine.data('xProductMedia', (settings) => ({
      thumbnailOnMouseDown: false,
      thumbnailOfset: 0,
      thumbnailScrollOfset: 0,
      thumbnailGrabbingClass: '',
      zoomIsOpen: false,
      productMediaIsOpen: '',
      videoExternalListened: false,
      videoAutoplayRetryCount: 0,
      videoAutoplayRetryScheduled: false,
      thumbnailHandleMouseDown(e) {
        this.thumbnailOnMouseDown = true;
        this.thumbnailGrabbingClass = 'cursor-grabbing';
        if (settings.thumbnail_direction == 'horizontal') {
          this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
          this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
        } else {
          this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
          this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
        }
      },
      thumbnailHandleMouseMove(e) {
        if(!this.thumbnailOnMouseDown) return;
        e.preventDefault();
        if (settings.thumbnail_direction == 'horizontal') {
          const x = e.pageX - this.$refs.thumbnail.offsetLeft;
          const walk = (x - this.thumbnailOfset) * 2;
          this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
        }
        else {
          const y = e.pageY - this.$refs.thumbnail.offsetTop;
          const walk = (y - this.thumbnailOfset) * 2;
          this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
        }
      },
      thumbnailHandleMouseLeave() {
        this._thumbnailRemoveGrabing();
      },
      thumbnailHandleMouseUp() {
        this._thumbnailRemoveGrabing();
      },
      _thumbnailRemoveGrabing() {
        this.thumbnailOnMouseDown = false;
        this.thumbnailGrabbingClass = 'md:cursor-grab';
      },
      zoomOpen(position) {
        this.zoomIsOpen = true;
        Alpine.store('xPopup').open = true;
        setTimeout(() => {
          document.getElementById(position + '-image-zoom-' + settings.section_id).scrollIntoView()
        }, 10);
        Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
      },
      zoomClose() {
        this.zoomIsOpen = false;
        Alpine.store('xPopup').open = false;
      },

      videoHandleIntersect() {
        if (!settings.video_autoplay) return;

        const xVideo = Alpine.store('xVideo');
        if (xVideo && typeof xVideo.play === 'function') {
          this.videoAutoplayRetryCount = 0;
          this.videoAutoplayRetryScheduled = false;
          xVideo.play(this.$el);
          return;
        }

        // video.js can be injected after the first intersect fires; retry briefly once the store exists.
        if (this.videoAutoplayRetryScheduled || this.videoAutoplayRetryCount >= 10) return;

        this.videoAutoplayRetryScheduled = true;
        this.videoAutoplayRetryCount += 1;
        setTimeout(() => {
          this.videoAutoplayRetryScheduled = false;
          this.videoHandleIntersect();
        }, 50);
      },
      productModelInit() {
        window.Shopify.loadFeatures([
          {
            name: 'shopify-xr',
            version: '1.0',
            onLoad: this._productModelSetupShopifyXR,
          },
        ]);
      },
      _productModelSetupShopifyXR() {
        const setup = () => {
          document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
            window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
            modelJSON.remove();
          });
          window.ShopifyXR.setupXRElements();
        }

        if (!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', () => {
            setup();
          });
          return;
        }

        setup();
      },
      productModelLoadMedia() {
        let container = this.$el.parentNode;
        const content = document.createElement('div');
        content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));

        this.$el.classList.add('hidden');
        container.appendChild(content.querySelector('model-viewer'));

        this._productModelLoadViewerUI();
      },
      productModelPauseViewer() {
        if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
      },
      _productModelLoadViewerUI() {
        window.Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this._productModelSetupViewerUI.bind(this),
          },
        ]);
      },
      _productModelSetupViewerUI(errors) {
        if (errors) return;

        this.$el.parentNode.modelViewerUI
          = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer'));
      }
    }));
  };

  requestAnimationFrame(() => {
    if (window.Alpine && window.Alpine.version) {
      registerProductMedia();
      return;
    }

    document.addEventListener('alpine:init', registerProductMedia, { once: true });
  });

  // Deferred video loading - activates video when it becomes visible
  const initDeferredVideos = () => {
    const deferredContainers = document.querySelectorAll('[data-deferred-video="true"]');

    if (deferredContainers.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const container = entry.target;
          const template = container.querySelector('.deferred-video-template');
          const poster = container.querySelector('.deferred-video-poster');

          if (template && !container.querySelector('video')) {
            // Clone and insert video from template
            const videoContent = template.content.cloneNode(true);
            container.appendChild(videoContent);

            const video = container.querySelector('video');
            if (video) {
              // Wait for video to be ready before hiding poster
              const hidePoster = () => {
                if (poster) {
                  poster.style.opacity = '0';
                  setTimeout(() => poster.remove(), 300);
                }
              };

              // Check if video is already ready
              if (video.readyState >= 3) {
                hidePoster();
                video.play().catch(() => {});
              } else {
                video.addEventListener('canplay', () => {
                  hidePoster();
                  video.play().catch(() => {});
                }, { once: true });
              }
            }

            // Stop observing this container
            observer.unobserve(container);
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '-100px'
    });

    deferredContainers.forEach((container) => {
      observer.observe(container);
    });
  };

  // Handle autoplay video posters - fade out when video plays
  const initAutoplayPosters = () => {
    const autoplayPosters = document.querySelectorAll('.autoplay-video-poster');

    autoplayPosters.forEach((poster) => {
      const container = poster.closest('.external-video');
      if (!container) return;

      const video = container.querySelector('video');
      if (!video) return;

      const hidePoster = () => {
        poster.style.opacity = '0';
        setTimeout(() => {
          poster.style.display = 'none';
        }, 300);
      };

      // Check if video is already playing
      if (video.readyState >= 3 && !video.paused) {
        hidePoster();
      } else {
        video.addEventListener('playing', hidePoster, { once: true });
      }
    });
  };

  // Check if mobile (< 768px)
  const isMobile = () => window.innerWidth < 768;

  // Load videos only after user interaction on desktop
  // On mobile, load immediately (LCP was already good there)
  const initAfterInteraction = () => {
    // Mobile: load videos immediately
    if (isMobile()) {
      initDeferredVideos();
      initAutoplayPosters();
      return;
    }

    // Desktop: wait for user interaction
    let initialized = false;

    const init = () => {
      if (initialized) return;
      initialized = true;

      ['scroll', 'click', 'touchstart', 'keydown'].forEach(event => {
        window.removeEventListener(event, init, { passive: true });
      });

      requestAnimationFrame(() => {
        initDeferredVideos();
        initAutoplayPosters();
      });
    };

    ['scroll', 'click', 'touchstart', 'keydown'].forEach(event => {
      window.addEventListener(event, init, { passive: true, once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAfterInteraction);
  } else {
    initAfterInteraction();
  }
}
